<template>
  <div class="layout">
    <!-- <contacUs></contacUs> -->
    <st-header v-show="!getRouter"></st-header>
    <!-- 面包屑 -->
    <breadcrumb class="breadcrumb-container" />
    <!-- 页面内容 -->
    <app-main />
    <StFooter v-if="getRouterFooter"></StFooter>
  </div>
</template>

<script>
import StHeader from "@/layout/header";
import StFooter from "@/layout/footer";
// import contacUs from "@/layout/contacUs";

import { AppMain, Breadcrumb } from "./components";
export default {
  name: "Index",
  components: {
    StHeader,
    Breadcrumb,
    AppMain,
    StFooter,
    // contacUs,
  },
  data() {
    return {
      showFooter: "",
    };
  },

  methods: {},

  computed: {
    getRouter() {
      let paths = [];
      let matchArr = [];
      paths.forEach((item) => {
        if (this.$route.path.includes(item)) {
          matchArr.push(item);
        }
      });
      return matchArr.length > 0;
    },

    getRouterFooter() {
      let paths = [
        "/Showcases",
        "/Events",
        "/NewsInfo",
        "/Connections",
        "/AboutUs",
        "/Accelerator",
      ];
      let sta = true;
      console.log(this.$route.path);
      if (paths.includes(this.$route.path)) {
        sta = false;
      }
      console.log(sta);
      return sta;
    },
  },
};
</script>

<style scoped></style>
